import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LegendItem } from "app/shared/data-interaction";
import { Helper } from "app/shared/helper";
import { Logger } from "app/shared/services/logger.service";
import { Chart } from "chart.js";

@Component({
  selector: "app-minergie",
  templateUrl: "./minergie.component.html",
  styleUrls: ["./minergie.component.css"]
})
export class MinergieComponent implements OnInit {
  @ViewChild("chartMinergie") canvas;
  @Input() type;
  @Input() chart_id;
  @Input() options;
  @Input() indicator;
  @Input() sample_data;
  @Input() chartData;
  @Input() value_type;
  @Input() unit;
  @Input() show_network_mix;
  @Input() totals_in_tooltip; // true if we want to display the totals in the tooltip

  private yAxeLabel: String;
  //To change or improve
  private chart: Chart;
  public minergieData: any;
  private areaChartDatasets;
  private yAxes;
  private localOptions;
  private legendItems: LegendItem[] = [];

  constructor(
    private helper: Helper,
    private translateService: TranslateService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes) {
    if (changes.options && changes.options.currentValue) {
      this.localOptions = JSON.parse(JSON.stringify(this.options));
      if (this.type === "bar") {
        this.localOptions.scales.yAxes[0]["ticks"] = {
          fontColor: "black",
          fontSize: 12,
        };
      }
    }
    this.createMinergieChart();
    this.updateLegend();
  }

  getTranslatedLabel(labelToTranslate) {
    return this.translateService.instant("DATA." + labelToTranslate);
  }

  createMinergieChart() {
    this.resetChart();
    if (this.sample_data) {
      this.minergieData = this.getSampleData();
    } else {
      if (this.chartData) {
        this.yAxeLabel = this.translateService.instant(
          `DASHBOARD.CHARTS.${this.chart_id}.LEFT_Y_LABEL_NAME`
        );
        this.minergieData = { labels: this.chartData["labels"] };
        this.minergieData["datasets"] = this.chartData["datasets"];
        /* var unit_from_config = this.helper.getUnitIdFromFilterValue(
          this.value_type,
          this.unit["money"]
        ); */
        this.yAxeLabel += this.translateService.instant(`UNITS.area.abs_m2`);
        this.localOptions["scales"]["yAxes"][0]["scaleLabel"][
          "labelString"
        ] = this.yAxeLabel;
        var i;
        for (i = 0; i < this.minergieData["datasets"].length; i++) {
          this.minergieData["datasets"][i]["label"] = this.getTranslatedLabel(
            this.minergieData["datasets"][i]["label"]
          );
        }
      }
    }
    // Define behavior of tooltip label for the chart
    this.localOptions.tooltips.callbacks.label = (item, data) => {
      let unit;
      unit = this.translateService.instant(`UNITS.area.abs_m2`);
      return [
        `${data.datasets[item.datasetIndex]
          .label} : ${this.helper.getThousandSeparatorFromNumber(
          item.yLabel
        )} ` + unit
      ];
    };
    this.localOptions.responsive = true;
    const ctx = this.canvas.nativeElement.getContext("2d");
    /* if (this.display_option == "stacked"){
      this.localOptions.scales.yAxes[0].stacked = true;
    } */
    this.localOptions["maintainAspectRatio"] = false;
    this.localOptions.legend.display = false;
    this.yAxes = [
      {
        id: "left",
        position: "left",
        type: "linear",
        scaleLabel: {
          display: true,
          labelString: this.yAxeLabel,
          fontColor: "black",
          fontSize: 14
        },
        ticks: {
          beginAtZero: true,
          callback: this.yAxisTicksCallback
        }
      }
    ];
    this.localOptions.scales.yAxes = this.yAxes;
    // configure tooltip footer to display total values
    // don't display if not specified in configuration and for % (total will always be 100%)
    if (this.value_type != "pourcent" && this.totals_in_tooltip) {
      this.localOptions.tooltips.callbacks.footer = (item, data) => {
        // hovered data indices
        const datasetIndex = item[0].datasetIndex;
        const dataIndex = item[0].index;

        // raw values
        let total = this.chartData.totals[dataIndex];
        let unit = "area.abs_m2"; //data.datasets[datasetIndex].unit[dataIndex];

        // format values
        [total, unit] = this.helper.convertTooBigValue(total, unit);
        total = this.helper.getThousandSeparatorFromNumber(total);
        unit = this.translateService.instant("UNITS." + unit);
        const total_translation = this.translateService.instant(
          `DASHBOARD.CHARTS.${this.chart_id}.TOTAL_TOOLTIP`
        );

        return [total_translation, total + " " + unit];
      };
    } else {
      // disable the footer callback to not display the totals
      this.localOptions.tooltips.callbacks.footer = (item, data) => {
        return [];
      };
    }
    this.chart = new Chart(ctx, {
      type: this.type,
      data: this.minergieData,
      options: this.localOptions
    });
  }

  yAxisTicksCallback = value => {
    // add thousand separator where needed, and round values larger than 10
    return this.helper.getThousandSeparatorFromNumber(value);
  };

  resetChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = void 0;
    }
  }

  updateLegend() {
    this.legendItems = [];
    if (this.chart) {
      // legend element is corresponds to each dataset and its color
      this.chart.data.datasets.forEach(dataset => {
        const legendItem: LegendItem = {
          label: dataset.label,
          color: dataset.backgroundColor,
          borderColor: dataset.backgroundColor,
          borderStyle: "none",
          clicked: false,
          datasetIndices:[]
        };

        this.legendItems.push(legendItem);
      });
    }
  }

  onLegendClick(legendIndex: number) {
    let clickedDataset = this.chart.data.datasets[legendIndex];
    clickedDataset.hidden = !clickedDataset.hidden;
    this.chart.update();
  }

  getSampleData() {
    let networksChartLabels = [2017, 2018, 2019, 2020];
    let gazData = [104490000, 98973204, 92026299, 90000000];
    let dhnData = [4500000, 5475000, 6450000, 8250000];
    var dcnData = [0, 10000000, 50000000, 50000000];

    var sampleData = {
      labels: networksChartLabels
    };
    if (!this.show_network_mix) {
      this.areaChartDatasets = [
        {
          label: "Réseau de gaz",
          data: gazData,
          stack: "gaz",
          backgroundColor: "rgba(50, 50, 50, 0.3)",
          borderColor: "rgba(50, 50, 50)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "Réseaux CAD",
          data: dhnData,
          stack: "dhn",
          backgroundColor: "rgba(164, 24, 211, 0.3)",
          borderColor: "rgba(164, 24, 211)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        }
      ];
    } else if (this.show_network_mix) {
      this.areaChartDatasets = [
        {
          label: "Gaz - Gaz naturel",
          data: gazData.map(function(x) {
            return x * 0.95;
          }),
          stack: "gaz",
          backgroundColor: "rgba(50, 50, 50, 0.3)",
          borderColor: "rgba(50, 50, 50)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "Gaz - Biogaz",
          data: gazData.map(function(x) {
            return x * 0.05;
          }),
          stack: "gaz",
          backgroundColor: "rgba(204, 153, 51, 0.3)",
          borderColor: "rgba(204, 153, 51)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "CAD - Bois",
          data: dhnData.map(function(x) {
            return x * 0.5;
          }),
          stack: "dhn",
          backgroundColor: "rgba(153, 102, 51, 0.3)",
          borderColor: "rgba(153, 102, 51)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "CAD - Gaz",
          data: dhnData.map(function(x) {
            return x * 0.2;
          }),
          stack: "dhn",
          backgroundColor: "rgba(50, 50, 50, 0.3)",
          borderColor: "rgba(50, 50, 50)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "CAD - PAC",
          data: dhnData.map(function(x) {
            return x * 0.3;
          }),
          stack: "dhn",
          backgroundColor: "rgba(51, 204, 153, 0.3)",
          borderColor: "rgba(51, 204, 153)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "FAD - Eau lac",
          data: dcnData.map(function(x) {
            return x * 0.9;
          }),
          stack: "dhn",
          backgroundColor: "rgba(0, 153, 204, 0.3)",
          borderColor: "rgba(0, 153, 204)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        },
        {
          label: "FAD - Elec",
          data: dcnData.map(function(x) {
            return x * 0.1;
          }),
          stack: "dhn",
          backgroundColor: "rgba(0, 51, 153, 0.3)",
          borderColor: "rgba(0, 51, 153)",
          borderWidth: 1,
          lineTension: 0,
          yAxisID: "mwh"
        }
      ];
    }
    sampleData["datasets"] = this.areaChartDatasets;
    return sampleData;
  }
}
